<script>
const HTML_TAGS = ['div', 'section', 'header', 'aside', 'footer', 'article'];

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      resolvedComponent: this.name ? this.resolve(this.name) : null,
      failed: false,
    };
  },

  watch: {
    name(name) {
      // only needed if prop can change after mount
      if (!name) {
        this.resolvedComponent = null;
        return;
      }

      this.resolvedComponent = this.resolve(name);
    },
  },

  methods: {
    resolve(name) {
      if (HTML_TAGS.includes(name)) {
        return name;
      }

      try {
        return require(`./${name}.vue`).default;
      } catch {
        this.failed = true;

        return null;
      }
    },
  },

  render(h) {
    if (!this.resolvedComponent || this.failed) {
      return this.$slots.default.length === 1 ? this.$slots.default[0] : h('div', this.$slots.default);
    }

    return h(this.resolvedComponent, this.$slots.default);
  },
};
</script>
